<template>
<Toolbar>
  <ToolbarGroup v-if="false">
    <ToolbarButton class="btn-x" title="Izaberite kolone">
      <i class="fa-solid fa-bars"></i>
    </ToolbarButton>
  </ToolbarGroup>
  <ToolbarGroup>
    <RouterLink :to="newLink" class="btn btn-primary" title="Novo">
      <i class="fa-solid fa-plus"></i>
    </RouterLink>
  </ToolbarGroup>
</Toolbar>
</template>

<script>
export default {
  props: {
    newLink: {},
  },
}
</script>
